import React from "react";
import { Button, Icon } from "antd";
import { useSelector } from "react-redux";

import styles from "./styles/UserMenu.scss";
import LoggedInMenu from "./LoggedInMenu";
import { selectLoadedUser } from "../../routes/Auth/auth.ducks";
import { buildBaseUrl } from "../../services/utils";
import { navigateToLogin } from "../../history";


const UserMenu = (props) => {
  const { mobile } = props;
  const user = useSelector(selectLoadedUser);

  const handleLogout = () => {
    window.location.replace(buildBaseUrl("/authentication/logout"));
  };

  if (user) {
    return <LoggedInMenu user={user} handleLogout={handleLogout} />;
  }

  if (mobile) {
    return (
      <Button
        onClick={() => navigateToLogin()}
        className={styles.mobileSignedButton}
      >
        <Icon type="user" />
      </Button>
    );
  }

  return null;
}

UserMenu.defaultProps = {
  mobile: false,
  user: null
};


export default UserMenu;



// WEBPACK FOOTER //
// ./src/containers/UserMenu/index.tsx